import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { ReactPlugin } from '@microsoft/applicationinsights-react-js'

let ai: ApplicationInsights | null = null
let rp: ReactPlugin | null = null

export function initializeAppInsights(): ApplicationInsights {
  rp = new ReactPlugin()
  ai = new ApplicationInsights({
    config: {
      instrumentationKey: import.meta.env.VITE_APP_INSIGHT_INSTRUMENTAL_KEY,
      extensions: [rp],
    },
  })

  ai.loadAppInsights()
  return ai
}
